import { AuthContextProps, hasAuthParams } from "react-oidc-context";

type SigninState = { returnTo?: string };

// Вход през keycloak, след който приложението се връща на текущата страница.
// Без това redirect_uri винаги води към началната страница и връзка, отворена
// в нов раздел, губи адреса си.
export function signinRedirectHere(auth: AuthContextProps) {
  const state: SigninState = {
    returnTo:
      window.location.pathname + window.location.search + window.location.hash,
  };
  return auth.signinRedirect({ state });
}

// Пренасочване към keycloak, ако няма запазен потребител. Ако има, но токенът
// му е изтекъл, първо се опитва подновяване с refresh токена (вж.
// userManager.ts), а при неуспех потребителят се премахва и тогава се стига
// дотук.
export function shouldSigninRedirect(auth: AuthContextProps) {
  return (
    !auth.user &&
    !auth.isLoading &&
    !auth.activeNavigator &&
    !hasAuthParams()
  );
}

// Адресът, запазен от signinRedirectHere - само път в приложението, никога
// друг сайт
export function returnToFromSigninState(state: unknown): string | undefined {
  const returnTo = (state as SigninState | undefined)?.returnTo;
  return typeof returnTo === "string" &&
    returnTo.startsWith("/") &&
    !returnTo.startsWith("//") &&
    !returnTo.startsWith("/\\")
    ? returnTo
    : undefined;
}
